module.exports = {
	"1": {
		"id": 1,
		"name": "packing_services",
		"title": "Необходимы услуги по упаковке",
		"type": "checkbox",
		"tip": "Услуга упаковки предоставляется только при заказе грузчиков и включает в себя защиту отдельных грузов упаковочной стрейч пленкой. Стоимость стрейч пленки и работ по упаковке зависит от объема работ по упаковке."
	},
	"2": {
		"id": 2,
		"name": "dismantling_assembling_furniture",
		"title": "Необходим такелаж (ремни, стропы, брус)",
		"type": "checkbox",
		"tip": "Перевозчик обеспечивает необходимое количество ремней и приспособлений для предотвращения смещения груза во время его перевозки."
	},
	"3": {
		"id": 3,
		"name": "hold_stuff",
		"title": "Необходимо хранение груза",
		"type": "checkbox"
	},
	"4": {
		"id": 4,
		"name": "hold_stuff_time",
		"title": "Время хранения груза",
		"type": "number"
	},
	"5": {
		"id": 5,
		"name": "stuff_on_stuff",
		"title": "Установка вещей друг на друга по согласованию с заказчиком",
		"type": "checkbox"
	},
	"7": {
		"id": 7,
		"name": "stuff_insurance",
		"title": "Необходимо застраховать груз",
		"type": "checkbox",
		"tip": "Заказчик может дополнительно застраховать груз в страховой компании – партнере сервиса «Везёт Всем» и указать свою оценку стоимости груза с учетом его износа."
	},
	"8": {
		"id": 8,
		"name": "documents",
		"title": "Необходимы первичные документы",
		"type": "list",
		"tip": "Если необходима отчетность по перевозке: договор, счет/квитанция, акт выполненных работ/счет-фактура.",
		"values": [
			{
				"id": 7,
				"value": "Договор",
				"order_param_id": 8,
				"is_default": 1
			},
			{
				"id": 8,
				"value": "Опись",
				"order_param_id": 8,
				"is_default": 0
			},
			{
				"id": 9,
				"value": "ТТН",
				"order_param_id": 8,
				"is_default": 0
			},
			{
				"id": 10,
				"value": "Акты",
				"order_param_id": 8,
				"is_default": 0
			}
		]
	},
	"9": {
		"id": 9,
		"name": "just_know_price",
		"title": "Груз не готов, просто узнать цену перевозки",
		"type": "checkbox",
		"tip": "Если ваш груз не готов или отсутсвует, при выборе этого параметра вы получите полный обзор цен от перевозчиков, не обременяя себя дополнительными обязательствами."
	},
	"10": {
		"id": 10,
		"name": "payment_methods",
		"title": "Способы оплаты",
		"type": "list",
		"values": [
			{
				"id": 1,
				"value": "Наличные",
				"order_param_id": 10,
				"tip": "Оплата наличными водителю за услугу перевозки, оплата наличными услуг сервиса «Везёт Всем» не предусмотрена",
				"is_default": 0
			},
			{
				"id": 2,
				"value": "Безналичный",
				"order_param_id": 10,
				"tip": "Оплата безналичным банковским переводом со банковского счета заказчика (юр. лица, ИП, физ. Лица) с предоставлением закрывающих документов за оказание услуги бронирования перевозки грузов.",
				"is_default": 0
			},
			{
				"id": 3,
				"value": "С НДС",
				"order_param_id": 10,
				"is_default": 0
			},
			{
				"id": 4,
				"value": "Без НДС",
				"order_param_id": 10,
				"is_default": 0
			},
			{
				"id": 5,
				"value": "Банковская карта",
				"order_param_id": 10,
				"tip": "Оплата банковской картой физического лица или компании.",
				"is_default": 0
			},
			{
				"id": 6,
				"value": "Перевод",
				"order_param_id": 10,
				"is_default": 0
			},
			{
				"id": 17,
				"value": "Блиц-перевод",
				"order_param_id": 10,
				"tip": "Перевод через одну из систем мгновенных денежных переводов, например Western Union.",
				"is_default": 0
			},
			{
				"id": 18,
				"value": "Без НДС или с НДС",
				"order_param_id": 10,
				"is_default": 1
			}
		]
	},
	"11": {
		"id": 11,
		"name": "loaders",
		"title": "Необходимы услуги грузчиков",
		"type": "checkbox"
	},
	"12": {
		"id": 12,
		"name": "load_floor",
		"title": "Этаж погрузки",
		"type": "number"
	},
	"13": {
		"id": 13,
		"name": "unload_floor",
		"title": "Этаж выгрузки",
		"type": "number"
	},
	"14": {
		"id": 14,
		"name": "load_elevator",
		"title": "Лифт погрузки",
		"type": "list",
		"values": [
			{
				"id": 11,
				"value": "Лифт отсутствует",
				"order_param_id": 14,
				"is_default": 1
			},
			{
				"id": 12,
				"value": "Пассажирский",
				"order_param_id": 14,
				"is_default": 0
			},
			{
				"id": 13,
				"value": "Грузовой",
				"order_param_id": 14,
				"is_default": 0
			}
		]
	},
	"15": {
		"id": 15,
		"name": "unload_elevator",
		"title": "Лифт выгрузки",
		"type": "list",
		"values": [
			{
				"id": 14,
				"value": "Лифт отсутствует",
				"order_param_id": 15,
				"is_default": 1
			},
			{
				"id": 15,
				"value": "Пассажирский",
				"order_param_id": 15,
				"is_default": 0
			},
			{
				"id": 16,
				"value": "Грузовой",
				"order_param_id": 15,
				"is_default": 0
			}
		]
	},
	"16": {
		"id": 16,
		"name": "load_elevator_not_fit",
		"title": "Груз не входит в лифт",
		"type": "checkbox"
	},
	"17": {
		"id": 17,
		"name": "unload_elevator_not_fit",
		"title": "Груз не входит в лифт",
		"type": "checkbox"
	},
	"18": {
		"id": 18,
		"name": "passing",
		"title": "Перевозка попутным грузом",
		"type": "checkbox",
		"tip": "В машине будет груз других заказчиков, перевозка будет стоить дешевле, но займёт больше времени"
	},
	"19": {
		"id": 19,
		"name": "outsized",
		"title": "Негабарит",
		"type": "checkbox"
	},
	"20": {
		"id": 20,
		"name": "book_separate_car",
		"title": "Заказать отдельную машину",
		"type": "checkbox"
	},
	"21": {
		"id": 21,
		"name": "manipulator",
		"title": "Заказать манипулятор",
		"type": "checkbox"
	},
	"22": {
		"id": 22,
		"name": "containers_and_railway",
		"title": "Контейнеры и перевозка по ЖД",
		"type": "checkbox"
	},
	"23": {
		"id": 23,
		"name": "description",
		"title": "Общее описание грузов",
		"type": "text"
	},
	"24": {
		"id": 24,
		"name": "truck_body_type_open",
		"title": "Любой открытый",
		"type": "list",
		"values": [
			{
				"id": 40,
				"value": "Борт",
				"order_param_id": 24,
				"is_default": 0
			},
			{
				"id": 45,
				"value": "Шаланда",
				"order_param_id": 24,
				"is_default": 0
			},
			{
				"id": 53,
				"value": "Самосвал",
				"order_param_id": 24,
				"is_default": 0
			},
			{
				"id": 55,
				"value": "Опен топ",
				"order_param_id": 24,
				"is_default": 0
			},
			{
				"id": 92,
				"value": "Пирамида",
				"order_param_id": 24,
				"is_default": 0
			},
			{
				"id": 93,
				"value": "«Катюша»",
				"order_param_id": 24,
				"is_default": 0
			},
			{
				"id": 94,
				"value": "Шасси",
				"order_param_id": 24,
				"is_default": 0
			},
			{
				"id": 101,
				"value": "Манипулятор",
				"order_param_id": 24,
				"is_default": 0
			}
		]
	},
	"25": {
		"id": 25,
		"name": "loading_type",
		"title": "Тип погрузки",
		"type": "list",
		"values": [
			{
				"id": 28,
				"value": "Любая",
				"order_param_id": 25,
				"is_default": 1
			},
			{
				"id": 29,
				"value": "Верхняя",
				"order_param_id": 25,
				"is_default": 0
			},
			{
				"id": 30,
				"value": "Боковая",
				"order_param_id": 25,
				"is_default": 0
			},
			{
				"id": 31,
				"value": "Задняя",
				"order_param_id": 25,
				"is_default": 0
			},
			{
				"id": 32,
				"value": "Полная растентовка",
				"order_param_id": 25,
				"is_default": 0
			},
			{
				"id": 33,
				"value": "Снятие поперечин",
				"order_param_id": 25,
				"is_default": 0
			},
			{
				"id": 34,
				"value": "Снятие стоек",
				"order_param_id": 25,
				"is_default": 0
			},
			{
				"id": 35,
				"value": "Без ворот",
				"order_param_id": 25,
				"is_default": 0
			},
			{
				"id": 36,
				"value": "Гидроборт",
				"order_param_id": 25,
				"is_default": 0
			},
			{
				"id": 37,
				"value": "Аппарели",
				"order_param_id": 25,
				"is_default": 0
			},
			{
				"id": 38,
				"value": "С бортами",
				"order_param_id": 25,
				"is_default": 0
			},
			{
				"id": 39,
				"value": "Обрешетка",
				"order_param_id": 25,
				"is_default": 0
			}
		]
	},
	"27": {
		"id": 27,
		"name": "need_belts",
		"title": "Необходимы ремни",
		"type": "checkbox"
	},
	"28": {
		"id": 28,
		"name": "need_pallets",
		"title": "Необходимы поддоны",
		"type": "checkbox"
	},
	"29": {
		"id": 29,
		"name": "adr",
		"title": "ADR",
		"type": "list",
		"values": [
			{
				"id": 76,
				"value": "1",
				"order_param_id": 29,
				"is_default": 0
			},
			{
				"id": 77,
				"value": "2",
				"order_param_id": 29,
				"is_default": 0
			},
			{
				"id": 78,
				"value": "3",
				"order_param_id": 29,
				"is_default": 0
			},
			{
				"id": 79,
				"value": "4",
				"order_param_id": 29,
				"is_default": 0
			},
			{
				"id": 80,
				"value": "5",
				"order_param_id": 29,
				"is_default": 0
			},
			{
				"id": 81,
				"value": "6",
				"order_param_id": 29,
				"is_default": 0
			},
			{
				"id": 82,
				"value": "7",
				"order_param_id": 29,
				"is_default": 0
			},
			{
				"id": 83,
				"value": "8",
				"order_param_id": 29,
				"is_default": 0
			},
			{
				"id": 84,
				"value": "9",
				"order_param_id": 29,
				"is_default": 0
			},
			{
				"id": 91,
				"value": "Не выбран",
				"order_param_id": 29,
				"is_default": 1
			}
		]
	},
	"30": {
		"id": 30,
		"name": "tir",
		"title": "TIR",
		"type": "checkbox"
	},
	"31": {
		"id": 31,
		"name": "crm",
		"title": "CRM",
		"type": "checkbox"
	},
	"32": {
		"id": 32,
		"name": "medical_book",
		"title": "Мед. книжка",
		"type": "checkbox"
	},
	"33": {
		"id": 33,
		"name": "t1",
		"title": "T1",
		"type": "checkbox"
	},
	"34": {
		"id": 34,
		"name": "escort",
		"title": "Сопровождение",
		"type": "number",
		"tip": "Укажите, хотите ли вы лично сопровождать груз и если да, то каким количеством человек"
	},
	"37": {
		"id": 37,
		"name": "round_trip",
		"title": "Требуется кругорейс (туда – обратно)",
		"type": "checkbox",
		"tip": "Поиск перевозчика, обеспечивающего доставку различных грузов по выбранному маршруту в пункт назначения и обратно."
	},
	"38": {
		"id": 38,
		"name": "truck_body_type_close",
		"title": "Любой закрытый",
		"type": "list",
		"values": [
			{
				"id": 46,
				"value": "Тент",
				"order_param_id": 38,
				"is_default": 0
			},
			{
				"id": 48,
				"value": "Фургон",
				"order_param_id": 38,
				"is_default": 0
			},
			{
				"id": 49,
				"value": "Цельнометаллический",
				"order_param_id": 38,
				"is_default": 0
			}
		]
	},
	"41": {
		"id": 41,
		"name": "transportation_modes",
		"title": "Способы транспортировки",
		"type": "list",
		"values": [
			{
				"id": 71,
				"value": "Автовоз",
				"order_param_id": 41,
				"is_default": 1
			},
			{
				"id": 72,
				"value": "Буксирование",
				"order_param_id": 41,
				"is_default": 0
			},
			{
				"id": 74,
				"value": "ЖД контейнер",
				"order_param_id": 41,
				"is_default": 0
			},
			{
				"id": 75,
				"value": "Перегон",
				"order_param_id": 41,
				"is_default": 0
			},
			{
				"id": 85,
				"value": "ЖД багажное отделение",
				"order_param_id": 41,
				"is_default": 0
			},
			{
				"id": 86,
				"value": "Вагон-сетка",
				"order_param_id": 41,
				"is_default": 0
			},
			{
				"id": 87,
				"value": "Эвакуатор",
				"order_param_id": 41,
				"is_default": 0
			},
			{
				"id": 88,
				"value": "Фургон",
				"order_param_id": 41,
				"is_default": 0
			},
			{
				"id": 89,
				"value": "Манипулятор",
				"order_param_id": 41,
				"is_default": 0
			},
			{
				"id": 90,
				"value": "Авиа",
				"order_param_id": 41,
				"is_default": 0
			}
		]
	},
	"42": {
		"id": 42,
		"name": "stuff_ready",
		"title": "Груз готов к отправке",
		"type": "checkbox"
	},
	"43": {
		"id": 43,
		"name": "truck_body_type_temp",
		"title": "Температурные",
		"type": "list",
		"values": [
			{
				"id": 47,
				"value": "Изотермический фургон",
				"order_param_id": 43,
				"is_default": 0
			},
			{
				"id": 50,
				"value": "Рефрижератор",
				"order_param_id": 43,
				"is_default": 0
			}
		]
	},
	"44": {
		"id": 44,
		"name": "truck_body_type_outsized",
		"title": "Негабарит",
		"type": "list",
		"values": [
			{
				"id": 43,
				"value": "Низкорамный трейлер",
				"order_param_id": 44,
				"is_default": 0
			},
			{
				"id": 96,
				"value": "Трал",
				"order_param_id": 44,
				"is_default": 0
			}
		]
	},
	"45": {
		"id": 45,
		"name": "truck_body_type_passenger",
		"title": "Пассажирские",
		"type": "list",
		"values": [
			{
				"id": 51,
				"value": "Автобус",
				"order_param_id": 45,
				"is_default": 0
			},
			{
				"id": 52,
				"value": "Микроавтобус",
				"order_param_id": 45,
				"is_default": 0
			},
			{
				"id": 97,
				"value": "Легковой автомобиль",
				"order_param_id": 45,
				"is_default": 0
			}
		]
	},
	"46": {
		"id": 46,
		"name": "truck_body_type_other",
		"title": "Прочие",
		"type": "list",
		"values": [
			{
				"id": 44,
				"value": "Эвакуатор",
				"order_param_id": 46,
				"is_default": 0
			},
			{
				"id": 56,
				"value": "Мусоровоз",
				"order_param_id": 46,
				"is_default": 0
			},
			{
				"id": 57,
				"value": "Щеповоз",
				"order_param_id": 46,
				"is_default": 0
			},
			{
				"id": 58,
				"value": "Автоцестерна",
				"order_param_id": 46,
				"is_default": 0
			},
			{
				"id": 60,
				"value": "Битумовоз",
				"order_param_id": 46,
				"is_default": 0
			},
			{
				"id": 61,
				"value": "Цементовоз",
				"order_param_id": 46,
				"is_default": 0
			},
			{
				"id": 62,
				"value": "Миксер (бетоновоз)",
				"order_param_id": 46,
				"is_default": 0
			},
			{
				"id": 63,
				"value": "Зерновоз",
				"order_param_id": 46,
				"is_default": 0
			},
			{
				"id": 64,
				"value": "Муковоз",
				"order_param_id": 46,
				"is_default": 0
			},
			{
				"id": 65,
				"value": "Скотовоз",
				"order_param_id": 46,
				"is_default": 0
			},
			{
				"id": 66,
				"value": "Коневоз",
				"order_param_id": 46,
				"is_default": 0
			},
			{
				"id": 67,
				"value": "Автовоз",
				"order_param_id": 46,
				"is_default": 0
			},
			{
				"id": 68,
				"value": "Панелевоз",
				"order_param_id": 46,
				"is_default": 0
			},
			{
				"id": 69,
				"value": "Лесовоз",
				"order_param_id": 46,
				"is_default": 0
			},
			{
				"id": 98,
				"value": "Автотопливозаправщик",
				"order_param_id": 46,
				"is_default": 0
			},
			{
				"id": 99,
				"value": "Вакуумная машина",
				"order_param_id": 46,
				"is_default": 0
			},
			{
				"id": 100,
				"value": "Грузовой эвакуатор",
				"order_param_id": 46,
				"is_default": 0
			}
		]
	},
	"47": {
		"id": 47,
		"name": "sealing",
		"title": "Пломбирование",
		"type": "checkbox"
	},
	"48": {
		"id": 48,
		"name": "min_connick_number",
		"title": "Мин. количество конников",
		"type": "list",
		"values": [
			{
				"id": 102,
				"value": "0",
				"order_param_id": 48,
				"is_default": 1
			},
			{
				"id": 103,
				"value": "2",
				"order_param_id": 48,
				"is_default": 0
			},
			{
				"id": 104,
				"value": "3",
				"order_param_id": 48,
				"is_default": 0
			},
			{
				"id": 105,
				"value": "4",
				"order_param_id": 48,
				"is_default": 0
			},
			{
				"id": 106,
				"value": "5",
				"order_param_id": 48,
				"is_default": 0
			},
			{
				"id": 107,
				"value": "6",
				"order_param_id": 48,
				"is_default": 0
			}
		]
	},
	"49": {
		"id": 49,
		"name": "desired_budget",
		"title": "Желаемый бюджет (ставка)",
		"type": "number",
		"tip": "Для ускорения поиска перевозчика Вы можете указать свой желаемый бюджет (ставку) на перевозку, который в дальнейшем также сможете изменить в личном кабинете."
	},
	"50": {
		"id": 50,
		"name": "load_loaders",
		"title": "Грузчики на погрузке",
		"type": "checkbox"
	},
	"51": {
		"id": 51,
		"name": "unload_loaders",
		"title": "Грузчики на выгрузке",
		"type": "checkbox"
	},
	"52": {
		"id": 52,
		"name": "payment_online",
		"title": "Оплата картой или по QR-коду",
		"type": "checkbox"
	},
	"53": {
		"id": 53,
		"name": "payment_invoice",
		"title": "Безналичный расчет",
		"type": "checkbox"
	},
	"54": {
		"id": 54,
		"name": "payment_cash",
		"title": "Наличные на погрузке (+10% к цене)",
		"type": "checkbox"
	},
	"55": {
		"id": 55,
		"name": "payment_prepay",
		"title": "Предоплата",
		"type": "checkbox"
	},
	"56": {
		"id": 56,
		"title": "Кол-во грузчиков на загрузку",
		"name": "load_loaders_count",
		"type": "list",
		"values": [
			{
				"id": 108,
				"value": "1",
				"order_param_id": 56,
				"is_default": 0
			},
			{
				"id": 109,
				"value": "2",
				"order_param_id": 56,
				"is_default": 0
			},
			{
				"id": 110,
				"value": "3",
				"order_param_id": 56,
				"is_default": 0
			},
			{
				"id": 111,
				"value": "4",
				"order_param_id": 56,
				"is_default": 0
			}
		]
	},
	"57": {
		"id": 57,
		"title": "Кол-во грузчиков на разгрузку",
		"name": "unload_loaders_count",
		"type": "list",
		"values": [
			{
				"id": 112,
				"value": "1",
				"order_param_id": 57,
				"is_default": 0
			},
			{
				"id": 113,
				"value": "2",
				"order_param_id": 57,
				"is_default": 0
			},
			{
				"id": 114,
				"value": "3",
				"order_param_id": 57,
				"is_default": 0
			},
			{
				"id": 115,
				"value": "4",
				"order_param_id": 57,
				"is_default": 0
			}
		]
	},
	"58": {
		"id": 58,
		"title": "Водитель может быть грузчиком",
		"name": "carrier_can_be_loader",
		"type": "checkbox"
	},
	"59": {
		"id": 59,
		"title": "Оценочная стоимость груза",
		"name": "insurance_cargo_cost",
		"type": "number",
		"tip": "Заказчик указывает собственную оценку стоимости груза с учетом его износа. Завышенная оценочная стоимость может быть снижена страховой компанией."
	}
};


//////////////////
// WEBPACK FOOTER
// ./configs/parameters.config.json
// module id = 1593
// module chunks = 0